import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import UserHeader from '@/components/user/UserHeader';
import Footer from '@/components/layout/Footer';
import { ArrowLeft } from 'lucide-react';

const InvestirProjeto: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // Mapeamento de IDs para caminhos de imagem
  const imageMap = {
    '10': '/lovable-uploads/7a72b832-cca8-4f76-b696-877484eef2cd.png',
    '11': '/lovable-uploads/8ebd1cad-af0e-44a8-9673-7b314bce719d.png',
    '1': '/lovable-uploads/7df9c8cd-d9b9-413d-ab21-1002154f464e.png',
    '2': '/lovable-uploads/da2eef4d-ab19-4fc8-aabe-53c8ec1b0972.png',
    '3': '/lovable-uploads/9f0954fd-c5de-4287-a807-bde7cbf131a1.png',
  };

  const projectImage = imageMap[id as keyof typeof imageMap] || '/lovable-uploads/default-project.jpg';
  const projectName = {
    '10': 'Moeda Social Carbono',
    '11': 'Plante para Neutralizar',
    '1': 'Reflorestamento Mata Atlântica',
    '2': 'Energia Solar Comunitária',
    '3': 'Gestão de Resíduos Urbanos',
  }[id as keyof typeof imageMap] || 'Projeto';

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <UserHeader />
      
      {/* Botões de navegação */}
      <div className="bg-white px-6 py-4 border-b border-gray-200">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex space-x-2">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-gray-600 hover:text-[#0e7cb4]"
            >
              <ArrowLeft className="h-5 w-5 mr-1" />
              Voltar
            </button>
          </div>
        </div>
      </div>
      
      {/* Conteúdo principal */}
      <div className="flex-grow p-6 bg-gray-50">
        <div className="container mx-auto">
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <h1 className="text-2xl font-bold p-6 border-b">Investir em {projectName}</h1>
            
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Verificando carregamento de imagem</h2>
              
              <div className="mb-6">
                <p className="text-gray-700 mb-2">Imagem do projeto (caminho: {projectImage}):</p>
                <div className="border rounded-lg overflow-hidden h-64">
                  <img 
                    src={projectImage}
                    alt={`Imagem do ${projectName}`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      console.error(`Erro ao carregar imagem: ${projectImage}`);
                      e.currentTarget.src = "/lovable-uploads/default-project.jpg";
                    }}
                  />
                </div>
              </div>
              
              <div className="mb-6">
                <p className="text-gray-700 mb-2">Imagem de teste (fallback):</p>
                <div className="border rounded-lg overflow-hidden h-64">
                  <img 
                    src="/lovable-uploads/default-project.jpg"
                    alt="Imagem de teste"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              
              <Button 
                className="bg-[#0e7cb4] hover:bg-[#0a5c87] text-white"
                onClick={() => navigate(`/projeto/${id}`)}
              >
                Voltar para detalhes do projeto
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default InvestirProjeto; 